// Module
var code = "<md-button st-menu-click=\"$ctrl.aolSilentLogin()\" md-prevent-menu-close=\"md-prevent-menu-close\" ng-disabled=\"$ctrl.isLoading\" class=\"silent-login\" aria-label=\"Apply online\" flex> <span ng-bind=\"$ctrl.isLoading ? 'Please wait...' : $ctrl.url ? 'Open' : 'Apply online'\"></span> </md-button> ";
// Exports
module.exports = code;